import styled from 'styled-components';
import FadeIn from './FadeIn';

const SlideContainer = styled.div`
    animation: ${FadeIn} 0.4s;
`

export default SlideContainer;